<template>
  <el-tooltip
    placement="right"
    :open-delay="500"
    :disabled="!(menu.collapse || item.collapseShowTip)"
    popper-class="hot-key-tip-popper"
  >
    <div
      slot="content"
      class="hot-key-tip-content"
    >
      <span class="hot-key-tip-desc">{{ item.toolTip || title }}</span>
      <template v-for="(key, index) in item.hotKey">
        <em
          v-if="item.hotKey.length > 1 && index !== 0"
          :key="key + index"
          :class="['zkicon icontianjia_xiao', 'hot-key-tip-add']"
          class="emi"
        />
        <el-tag
          :key="key"
          class="hot-key-tip-tag"
        >
          <span>{{ key }}</span>
        </el-tag>
      </template>
    </div>
    <el-row
      :class="['zk-left-menu-item', { 'is-active': isActive, 'is-selected': isSelected }]"
      :data-menu="item.name"
      type="flex"
      align="middle"
      @mousedown.native="handleClick"
    >
      <slot
        name="prefix"
        :item="item"
      />
      <el-row
        v-ripple="{ center: false, circle: true }"
        type="flex"
        align="middle"
        class="zk-left-menu-item__content"
      >
        <slot
          v-if="item.icon"
          :item="item"
          name="icon"
        >
          <em :class="[item.icon, 'zk-left-menu-item__icon']" />
        </slot>
        <slot
          name="title"
          :item="item"
        >
          <el-new-badge
            ref="menuBadge"
            :key="item.name"
            v-bind="item.segment || { segments: false }"
            placement="right-start"
            hidden-on-click
            :click-report="true"
          >
            <span
              v-overflow-tooltip="{ placement: 'right', content: title }"
              class="text-ellipsis zk-left-menu-item__title"
            >
              {{ title }}
            </span>
          </el-new-badge>
        </slot>
        <slot
          name="suffix"
          :item="item"
        />
      </el-row>
      <div
        v-if="isActive"
        class="zk-left-menu-item__active"
      />
    </el-row>
  </el-tooltip>
</template>

<script>
export default {
  name: 'LeftMenuItem',
  inject: ['menu'],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed:{
    title() {
      return this.item.title || this.item.meta?.title;
    },
    isActive() {
      return this.item.active === true;
    },
    isSelected() {
      return this.item.selected === true;
    }
  },
  methods: {
    handleClick(event) {
      if (this.$listeners.click) {
        this.$emit('click', this.item, event);
        if (this.item.segment?.segments) {
          this.$refs.menuBadge?.onClick();
        }
      }
    }
  }
};
</script>

<style lang="scss">
$defaultColor: var(--purpleGray-5);
$hoverBg: var(--brand-transparent-active-1);
$activeBg: var(--primary-color);
$activeColor: var(--main-bg-color);
$height: 38px;

@include b(left-menu-item) {
  height: $height;
  line-height: $height;
  margin: 2px 0;
  padding: 0 12px;
  &:first-child {
    margin-top: 0;
  }
  @include when(active) {
    @include e(content) {
      @include iconColor($activeColor);
      @include e(icon) {
        color: $activeColor !important;
      }
      @include e(title) {
        color: $activeColor;
      }
    }
  }
  @include when(selected) {
    @include e(content) {
      background: $activeBg;
      @include iconColor($activeColor);
      @include e(icon) {
        color: $activeColor !important;
      }
      @include e(title) {
        color: $activeColor;
      }
    }
  }
  @include icon {
    color: $defaultColor;
  }
  @include e(icon) {
    flex-shrink: 0;
    color: $defaultColor !important;
    font-size: 18px;
    margin-right: 8px;
  }
  @include e(title) {
    color: $defaultColor;
   font-weight: var(--weight-font-Blod);
    flex: 1;
  }
  @include e(active) {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 8px 6px 8px 0;
    position: absolute;
    right: -1px;
    transition: opacity .1s ease-in-out;
    border-color: transparent #fff transparent transparent;
  }
  @include e(content) {
    height: 100%;
    overflow: hidden;
    cursor: pointer;
    flex: 1;
    border-radius: 16px;
    padding: 0 12px;
    &:hover {
      background: $hoverBg;
    }
  }
}
</style>
